import React, { useState } from "react";
import { AlertBox } from "../../../../../../../../shared/AlertBox/AlertBox";
import { Button } from "../../../../../../../../shared/Button/Button";
import { CircularProgress } from "../../../../../../../../shared/CircularProgress/CircularProgress";
import { InputPhone } from "../../../../../../../../shared/InputPhone/InputPhone";
import { Modal } from "../../../../../../../../shared/Modal/Modal";
import styles from "./styles.module.scss";
import { phoneUtil } from "../../../../../../../../utilities/phone";

const isValidPhone = (phone) => phoneUtil.isPossible(phoneUtil.compose(phone));

export const ModalBlock = ({ onSubmit, onClose, isSubmitting }) => {
  const [phone, setPhone] = useState("");

  const handleBlock = () => {
    if (isValidPhone(phone)) {
      onSubmit(phone).then(onClose);
    }
  };

  return (
    <Modal
      isOpen
      footerNoBorder
      size="small"
      onClose={onClose}
      shouldCloseOnOverlayClick={false}
      header={<Modal.Title>Confirmation required!</Modal.Title>}
      contentClassName={styles.root}
      footer={
        <div className={styles.footer}>
          <Button
            isDisabled={!isValidPhone(phone) || isSubmitting}
            color="error"
            onClick={handleBlock}
            leftAdornment={
              isSubmitting ? (
                <CircularProgress size="small" color="white" />
              ) : undefined
            }
          >
            Block
          </Button>
          <Button variant="outlined" onClick={onClose}>
            No
          </Button>
        </div>
      }
    >
      <AlertBox size="small">
        To proceed with blocking this user, please enter your phone number for
        verification.
      </AlertBox>
      <InputPhone fullWidth value={phone} onChange={setPhone} />
    </Modal>
  );
};
